import React, { useEffect, useState, Suspense, lazy } from 'react';
import { HomePage } from './pages/HomePage';
import { LanguageProvider } from './i18n/LanguageContext';
// Lazy load sub-pages — only HomePage loads eagerly (most common entry)
const SpecialistsPage = lazy(() => import('./pages/SpecialistsPage').then(m => ({
  default: m.SpecialistsPage
})));
const CompaniesPage = lazy(() => import('./pages/CompaniesPage').then(m => ({
  default: m.CompaniesPage
})));
// Minimal loading fallback
function PageLoader() {
  return <div className="min-h-screen bg-white flex items-center justify-center" data-id="element-0">
      <div className="w-8 h-8 border-2 border-[var(--color-tan)] border-t-transparent rounded-full animate-spin" data-id="element-1" />
    </div>;
}
function AppContent() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);
  const pathParts = currentPath.split('/');
  const page = pathParts[2];
  if (page === 'specialists') {
    return <Suspense fallback={<PageLoader data-id="element-3" />} data-id="element-2">
        <SpecialistsPage data-id="element-4" />
      </Suspense>;
  }
  if (page === 'companies') {
    return <Suspense fallback={<PageLoader data-id="element-6" />} data-id="element-5">
        <CompaniesPage data-id="element-7" />
      </Suspense>;
  }
  return <HomePage data-id="element-8" />;
}
export function App() {
  return <LanguageProvider data-id="element-9">
      <AppContent data-id="element-10" />
    </LanguageProvider>;
}